<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="/img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Conta</strong></b-dropdown-header>
      <b-dropdown-item @click="goToAccount()"><i class="fa fa-user" /> Minha Conta
      </b-dropdown-item>
      <b-dropdown-item @click="logout()"><i class="fa fa-lock" /> Sair</b-dropdown-item>
    </template>
  </AppHeaderDropdown>


</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import service from './../service'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout: function() {
      service.logout();
    },
    goToAccount: function() {
      this.$router.push("/account/");
    }
  }
}
</script>
